import {
  RulesEditorController
} from './rules-editor.component';

export class RulesEditorModalService {
  constructor($timeout, $modal) {
    this.$timeout = $timeout;
    this.$modal = $modal;
  }

  open(cut, filterService, asNew) {
    const updateModalSize = () => {
      $('.list-body').height((window.innerHeight * 0.96 -
        $('.modal-header').outerHeight() -
        $('.list-head').outerHeight() -
        $('.modal-footer').outerHeight()));
      $('.toolbar-color>div').innerWidth(document.querySelector('.list-body>div').clientWidth);
    };


    this.modalInstance = this.$modal.open({
      template: require('./rules-editor.component.html'),
      controller: RulesEditorController,
      resolve: {
        asNew: () => asNew,
        cut: () => cut,
      },
      windowClass: 'sc-rules-editor-modal',
    });
    this.modalInstance.opened
      .then(() => {
        this.$timeout(() => {
          updateModalSize();
        }, 100);
      })
      .catch((err) => {
        console.error(err);
      });
    return this.modalInstance.result;
  }
}



// WEBPACK FOOTER //
// ./src/filter/editor/rules-editor/rules-editor-modal.service.js